import React, { Component } from 'react'
import Switch from "react-switch";
import axios from 'axios';
import { CREATE_AGENT } from '../../config/rest_endpoints';
import { getUser } from '../../actions/session';
import { Notifications } from '../common/notification';
import Select from 'react-select';

export default class CreateAgent extends Component {
    constructor(props) {
        super(props)
        this.state = {  
            User:getUser(),
            name:'',
            email:'',
            phone:'',
            address:'',
            commission:'',
            selectType:[
                {label:"Profit",value:"profit"},
                {label:"Gross",value:"gross"}
            ],
            selectedType: {label:"Profit",value:"profit"},
            selectFreq:[
                {label:"Monthly",value:"monthly"},
                {label:"Weekly",value:"weekly"}
            ],
            selectedFreq: {label:"Monthly",value:"monthly"},
            switched:true,
            isLoad:false
        }

        this.onHandleChange = this.onHandleChange.bind(this)
        this.createAgent = this.createAgent.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.handleSelectFreq = this.handleSelectFreq.bind(this)
        this.handleSelectType = this.handleSelectType.bind(this)
    }

    onHandleChange(e) {
        this.setState({[e.target.name]:e.target.value})
    }

    handleSelectType(selectedType) {
        this.setState({ selectedType});
        console.log(`selectedType:`, selectedType);
        
    };

    handleSelectFreq(selectedFreq) {
        this.setState({ selectedFreq });
        console.log(`selectedFreq:`, selectedFreq);
    };

    toggleSwitch() {
        this.setState({switched:!this.state.switched})
    }

    createAgent() {
        const {name,email,phone,address,commission,freq,switched,User,selectedType,selectedFreq} = this.state
        var payload = {
            "name": name,
            "email": email,
            "phone": parseInt(phone),
            "address":address,
            "commission": `${commission}`,
            "type": selectedType.value,
            "frequency": selectedFreq.value,
            "active": switched
        }
        this.setState({isLoad:true})
        console.log('payload',payload)
        var headers = { "Authorization": "Bearer " + User.token };
        axios.post(`${CREATE_AGENT}`,payload,{headers}).then(res=>{
            if(res) {
                console.log(res)
                Notifications.notify('Agent Created',"Created",'success')
                this.props.close();
                this.props.listing();
                this.setState({isLoad:false})
            }
        }).catch(err=>{
            var msessage = err.response.data.message
            console.log(`msessage`, msessage)
            Notifications.notify(msessage, "Failed", "error")
            this.setState({isLoad:false})
        })
        
    }

    render() {
        const {name,email,phone,address,commission,freq,switched,type,selectedFreq,selectFreq,selectedType,selectType} = this.state
        return (
            <div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}} >Name</label>
                        <input type="text" className="form-control" name="name" value={name} onChange={this.onHandleChange} placeholder="Enter name" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}} >Email</label>
                        <input type="email" className="form-control" name="email" value={email} onChange={this.onHandleChange} placeholder="Enter email" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}}>Phone</label>
                        <input type="number" className="form-control" name="phone" value={phone} onChange={this.onHandleChange} placeholder="Enter phone" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}} >Address</label>
                        <input type="text" className="form-control" name="address" value={address} onChange={this.onHandleChange} placeholder="Enter address" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}}>Commission</label>
                        <input type="text" className="form-control" name="commission" value={commission} onChange={this.onHandleChange} placeholder="Enter commission" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}}>Type</label>
                        <Select
                            value={selectedType}
                            onChange={this.handleSelectType}
                            options={selectType}
                            placeholder="Select Type"
                        />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                        <label style={{fontWeight:'400',fontSize:'16px'}}>Frequency</label>
                        <Select
                            value={selectedFreq}
                            onChange={this.handleSelectFreq}
                            options={selectFreq}
                            placeholder="Select Frequency"
                        />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14" >Status</label><br/>
                            <Switch className='mt-1' onChange={this.toggleSwitch} checked={switched} onColor="#00C292"  />
                        </div>
                    </div>
                </div>
                <div className="row" style={{borderTop:'1px solid #e9ecef'}}>
                    <div className="col-md-6 ml-auto">
                        <button type="submit " className="main-button btn btn-success btn-sm mt-2 float-right"  disabled={this.state.isLoad ? true :false} onClick={this.createAgent} >
                             Create Agent <i class={this.state.isLoad ? "icon-spinner4 spinner ml-1 " : "icon-user-plus ml-1 icon-1x"}></i>   </button>
                    </div>
                </div>

            </div>
        )
    }
}
